import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$",
)({
  beforeLoad: ({ params }) => {
    const splat = params["_splat"] ?? "";
    throw redirect({
      to: `/builders/${params.builder_id}/locations/${params.community_id}/location-plans/${params.community_plan_id}/${splat}` as string,
      statusCode: 301,
    });
  },
});
